// extracted by mini-css-extract-plugin
export default {"parent":"Footer_parent__M+n3K","container":"Footer_container__JvzdI","icons":"Footer_icons__s3Q9U"};